import { render, staticRenderFns } from "./ViewType.vue?vue&type=template&id=e4bed856&scoped=true&"
import script from "./ViewType.vue?vue&type=script&lang=js&"
export * from "./ViewType.vue?vue&type=script&lang=js&"
import style0 from "./ViewType.vue?vue&type=style&index=0&id=e4bed856&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bed856",
  null
  
)

export default component.exports